import styled from 'styled-components';

export const PackagesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;
